import { createMemo, createUniqueId as _createUniqueId, } from "solid-js";
export default function createUniqueId(idOverride) {
    return createMemo(() => idOverride?.() ?? `mui-${_createUniqueId()}`);
}
